import React from "react";
import {
  List,
  Datagrid,
  EmailField,
  TextField,
  TextInput,
  EditButton,
  Filter,
  ReferenceField,
  SelectInput,
} from "react-admin";
import Chip from "@material-ui/core/Chip";
import SignInAsUser from "./SignInAsUser";
import { styles } from "../styles";

const UserFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Email" source="email" alwaysOn style={styles.input} />
    <TextInput label="Name" source="name" alwaysOn style={styles.input} />
    <TextInput
      label="Company name"
      source="companyName"
      alwaysOn
      style={styles.input}
    />
    <TextInput
      label="Company ID"
      source="companyId"
      alwaysOn
      style={styles.input}
    />
    <SelectInput
      label="By activity"
      addLabel
      source="lastActiveAt"
      choices={[
        { id: "today", name: "today" },
        { id: "week", name: "this week" },
      ]}
      style={styles.input}
    />
  </Filter>
);

const RoleField = (props) => {
  return props.record.roles.map((role) => (
    <Chip label={role} style={styles.chip} />
  ));
};

export default (props) => {
  return (
    <List
      {...props}
      title="All users"
      perPage={25}
      filters={<UserFilter />}
      bulkActionButtons={false}>
      <Datagrid>
        <TextField source="firstName" sortable style={styles.title} />
        <TextField source="lastName" sortable style={styles.title} />
        <EmailField source="email" sortable style={styles.title} />
        <ReferenceField
          label="Company"
          source="companyId"
          reference="admin/companies"
          linkType={false}>
          <TextField source="name" style={styles.title} />
        </ReferenceField>
        <RoleField label="Roles" />
        <EditButton />
        <SignInAsUser />
      </Datagrid>
    </List>
  );
};



// WEBPACK FOOTER //
// ./src/users/List.js